// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"101":"f6a0b84f","589":"ffdabcbe","777":"2c1f0bec","817":"e0e3e607","872":"53b92300","901":"e674742c"}[chunkId] + ".chunk.js";
};